/**
 * @packageDocumentation
 * @module HackerAPI.Utils
 */
/**
 * Converts a variable from camelcase to underscores
 * @param str
 * @returns
 */
export function underscores(str) {
    return str
        .split(/(?=[A-Z])/)
        .join("_")
        .toLowerCase();
}
/**
 * Converts a variable from underscores to camelcase
 * @param str
 * @returns
 */
export function camelCase(str) {
    return str.replace(/_([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });
}
/**
 * Returns a new object with the same data as cc but with keys with underscore naming convention instead
 * of camelcase
 * @param cc
 * let cc = {
 *   camelCase: true
 * }
 * let u = HackerAPI.Utils.toUnderscoreKeys(cc);
 * // u: { camel_case: true }
 */
export function toUnderscoreKeys(cc) {
    var u = {};
    Object.keys(cc).forEach(function (key) {
        u[underscores(key)] = cc[key];
    });
    return u;
}
/**
 * Converts a response from hackerapi into a data uri
 * @param res
 * @returns
 */
export function responseToDataUri(res) {
    var img;
    // For in the browser
    if (typeof btoa === "function") {
        img = btoa(new Uint8Array(res.data).reduce(function (data, byte) { return data + String.fromCharCode(byte); }, ""));
    }
    // For in Node
    else if (typeof Buffer === "function") {
        img = new Buffer(res.data, "binary").toString("base64");
    }
    // Maybe React Native?
    else {
        /** @todo Send custom error */
        throw new Error();
    }
    return "data:" + res.headers["content-type"].toLowerCase() + ";base64," + img;
}
/**
 * Parses a token
 * @param token
 * @param [token.token] - If object passed in
 * @returns Undefined if couldn't parse token
 */
export function parseToken(token) {
    if (typeof token === "string") {
        return token;
    }
    else if (token &&
        typeof token === "object" &&
        token.token &&
        typeof token.token === "string") {
        return token.token;
    }
    else {
        return undefined;
    }
}
/**
 * Parses a number field
 * @param underscored The hackerapi responses
 * @param camelcased The hackerapi.js field
 * @returns The number or undefined if neither format contained a number
 */
export function parseNumber(underscored, camelcased) {
    if (typeof underscored === "number") {
        return underscored;
    }
    else if (typeof camelcased === "number") {
        return camelcased;
    }
    else {
        return undefined;
    }
}
/**
 * Parses a boolean field
 * @param underscored
 * @param camelcased
 * @returns
 */
export function parseBoolean(underscored, camelcased) {
    if (typeof underscored === "boolean") {
        return underscored;
    }
    else if (typeof camelcased === "boolean") {
        return camelcased;
    }
    else {
        return undefined;
    }
}
/**
 * Parses a date field
 * @param the possible date
 * @returns
 */
export function parseDate(date) {
    if (date) {
        return new Date(date);
    }
    else {
        return undefined;
    }
}
/**
 * Parses a field that could be a string or null
 * @param underscored
 * @param camelcased
 * @returns
 */
export function parseStringOrNull(underscored, camelcased) {
    if (typeof underscored === "string" || underscored === null) {
        return underscored || undefined;
    }
    else if (typeof camelcased === "string" || camelcased === null) {
        return camelcased || undefined;
    }
    else {
        return undefined;
    }
}
/**
 * Parses a string field
 * @param underscored
 * @param camelcased
 * @returns
 */
export function parseString(underscored, camelcased) {
    if (typeof underscored === "string") {
        return underscored;
    }
    else if (typeof camelcased === "string") {
        return camelcased;
    }
    else {
        return undefined;
    }
}
export function parseArray(underscored, camelcased) {
    if (Array.isArray(underscored)) {
        return underscored;
    }
    else if (Array.isArray(camelcased)) {
        return camelcased;
    }
    else {
        return undefined;
    }
}
/**
 * Parses an array or null
 * @param underscored
 * @param camelcased
 * @returns
 */
export function parseArrayOrNull(underscored, camelcased) {
    if (Array.isArray(underscored) || underscored === null) {
        return underscored || [];
    }
    else if (Array.isArray(camelcased) || camelcased === null) {
        return camelcased || [];
    }
    else {
        return undefined;
    }
}
//# sourceMappingURL=utils.js.map